import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/HomeView',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/',
    name: 'Login',
    component: () => import("@/views/LoginPage.vue"),
  },
   {
    path: '/Signup',
    name: 'Signup',
    component: () => import("@/views/NewSignup.vue"),
  },
  {
    path: '/LoginRecharge',
    name: 'LoginRecharge',
    component: () => import("@/views/LoginRecharge.vue"),
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import("@/components/NavBar.vue"),
    children: [
      {
        path: "Dashboard",
        name: "Dashboard",
        component: () => import("../components/ChildHomePages/DashBordView.vue"),
      },
       {
        path: "Members",
        name: "Members",
        component: () => import("../components/ChildHomePages/MembersList.vue"),
      },
      {
        path: "Locations",
        name: "Locations",
        component: () => import("../components/ChildHomePages/LocationsList.vue"),
      },
      {
        path: "DailyPresentReport",
        name: "DailyPresentReport",
        component: () => import("../components/ChildHomePages/Reports/DailyReports/DailyPresentReport.vue"),
      },
      {
        path: "DailyAbsentReport",
        name: "DailyAbsentReport",
        component: () => import("../components/ChildHomePages/Reports/DailyReports/DailyAbsentReport.vue"),
      },
      {
        path: "DailyLateReport",
        name: "DailyLateReport",
        component: () => import("../components/ChildHomePages/Reports/DailyReports/DailyLateReport.vue"),
      },
      {
        path: "DailyProofWork",
        name: "DailyProofWork",
        component: () => import("../components/ChildHomePages/Reports/DailyReports/DailyProofWork.vue"),
      },
      {
        path: "DailyProxy",
        name: "DailyProxy",
        component: () => import("../components/ChildHomePages/Reports/DailyReports/DailyProxy.vue"),
      },
      {
        path: "LeaveReport",
        name: "LeaveReport",
        component: () => import("../components/ChildHomePages/Reports/DailyReports/DailyLeaveReport.vue"),
      },
      {
        path: "WeeklyData",
        name: "WeeklyData",
        component: () => import("../components/ChildHomePages/Reports/WeeklyData.vue"),
      },
      {
        path: "SwipeDataReport",
        name: "SwipeDataReport",
        component: () => import("../components/ChildHomePages/Reports/MonthlyReport/SwipeDataReport.vue"),
      },
      {
        path: "SwipeCountReport",
        name: "SwipeCountReport",
        component: () => import("../components/ChildHomePages/Reports/MonthlyReport/SwipeCountReport.vue"),
      },
      {
        path: "NormalizedReports",
        name: "NormalizedReports",
        component: () => import("../components/ChildHomePages/Reports/MonthlyReport/NormalizedReports.vue"),
      },
      {
        path: "LateArrivalReport",
        name: "LateArrivalReport",
        component: () => import("../components/ChildHomePages/Reports/MonthlyReport/LateArrivalReport.vue"),
      },
       {
        path: "EarlyGoers",
        name: "EarlyGoers",
        component: () => import("../components/ChildHomePages/Reports/MonthlyReport/EarlyGoers.vue"),
      },
      {
        path: "ShortDurationReport",
        name: "ShortDurationReport",
        component: () => import("../components/ChildHomePages/Reports/MonthlyReport/ShortDurationReport.vue"),
      },
      {
        path: "PresentReport",
        name: "PresentReport",
        component: () => import("../components/ChildHomePages/Reports/MonthlyReport/PresentReport.vue"),
      },
      {
        path: "WorkingHoliday",
        name: "WorkingHoliday",
        component: () => import("../components/ChildHomePages/Reports/MonthlyReport/WorkingHoliday.vue"),
      },
      {
        path: "AppUserReports",
        name: "AppUserReports",
        component: () => import("../components/ChildHomePages/Reports/AppUserReports.vue"),
      },
      {
        path: "ProofwrkReport",
        name: "ProofwrkReport",
        component: () => import("../components/ChildHomePages/Reports/ProofwrkReport.vue"),
      },
      {
        path: "DataCorrectionreport",
        name: "DataCorrectionreport",
        component: () => import("../components/ChildHomePages/Reports/DataCorrectionreport.vue"),
      },
       {
        path: "LiveTrackingReport",
        name: "LiveTrackingReport",
        component: () => import("../components/ChildHomePages/Reports/LiveTrackingReport.vue"),
      },
      {
        path: "LeavedataReport",
        name: "LeavedataReport",
        component: () => import("../components/ChildHomePages/Reports/LeaveReport.vue"),
      },
      {
        path: "LeaveApprovellist",
        name: "LeaveApprovellist",
        component: () => import("../components/ChildHomePages/LeaveApprovelList.vue"),
      },
      {
        path: "EsaTransaction",
        name: "EsaTransaction",
        component: () => import("../components/ChildHomePages/EsaTransaction.vue"),
      },
      {
        path: "ProfilApprove",
        name: "ProfilApprove",
        component: () => import("../components/ChildHomePages/ProfilApprove.vue"),
      },
      {
        path: "ScanLogs",
        name: "ScanLogs",
        component: () => import("../components/ChildHomePages/ScanLogs.vue"),
      },
      {
        path: "DataCorrection",
        name: "DataCorrection",
        component: () => import("../components/ChildHomePages/DataCorrection.vue"),
      },
      {
        path: "Administrators",
        name: "Administrators",
        component: () => import("../components/ChildHomePages/AdministratorList.vue"),
      },
      {
        path: "Transactions",
        name: "Transactions",
        component: () => import("../components/ChildHomePages/TransactionsList.vue"),
      },
      {
        path: "AuditLogs",
        name: "AuditLogs",
        component: () => import("../components/ChildHomePages/AuditLogs.vue"),
      },
      {
        path: "kiosk",
        name: "kiosk",
        component: () => import("../components/ChildHomePages/Settings/KioskList.vue"),
      },
      {
        path: "EsA",
        name: "EsA",
        component: () => import("../components/ChildHomePages/Settings/EsA.vue"),
      },
      {
        path: "WorkTimings",
        name: "WorkTimings",
        component: () => import("../components/ChildHomePages/Settings/WorkTimingsN.vue"),
      },
      {
        path: "HolidayList",
        name: "HolidayList",
        component: () => import("../components/ChildHomePages/Settings/HolidayList.vue"),
      },
      {
        path: "LeaveSettings",
        name: "LeaveSettings",
        component: () => import("../components/ChildHomePages/Settings/LeaveSettings.vue"),
      },
      {
        path: "DesginationList",
        name: "DesginationList",
        component: () => import("../components/ChildHomePages/Settings/DesginationList.vue"),
      },
      {
        path: "ExportReports",
        name: "ExportReports",
        component: () => import("../components/ChildHomePages/Reports/ExportReports.vue"),
    },
      {
        path: "EmployeetypeList",
        name: "EmployeetypeList",
        component: () => import("../components/ChildHomePages/Settings/EmployeetypeList.vue"),
      },
      {
        path: "OrganisationDetails",
        name: "OrganisationDetails",
        component: () => import("../components/ChildHomePages/Settings/OrganisationDetails.vue"),
      },
      {
        path: "ScanSettings",
        name: "ScanSettings",
        component: () => import("../components/ChildHomePages/Settings/ScanSettings.vue"),
      },
      {
        path: "ProofOfWorkType",
        name: "ProofOfWorkType",
        component: () => import("../components/ChildHomePages/Settings/ProofOfWorkType.vue"),
      },
      {
        path: "AdvanceSettings",
        name: "AdvanceSettings",
        component: () => import("../components/ChildHomePages/Settings/AdvanceSettings.vue"),
      },
      {
        path: "FaceScan",
        name: "FaceScan",
        component: () => import("../components/ChildHomePages/FaceScan.vue"),
      },
      {
        path: "ReportIssue",
        name: "ReportIssue",
        component: () => import("../components/ReportIssue.vue"),
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
